import graphqlClient from "../../../apollo";

class OfertaProvider {

    findOferta(id) {
        return graphqlClient.query({
            query: require('./gql/ofertaFind.graphql'),
            variables: { id: id },
            fetchPolicy: "network-only"
        })
    }

    fetchOfertas() {
        return graphqlClient.query({
            query: require('./gql/ofertaFetch.graphql'),
            fetchPolicy: "network-only"
        })
    }

    paginateOfertas(pageNumber, itemsPerPage, search = null, filters = [], orderBy = null, orderDesc = false) {
        return graphqlClient.query({
            query: require('./gql/ofertaPaginate.graphql'),
            variables: { pageNumber, itemsPerPage, search, filters, orderBy, orderDesc },
            fetchPolicy: "network-only"
        })
    }

    createOferta(form) {
        return graphqlClient.mutate({
            mutation: require('./gql/ofertaCreate.graphql'),
            variables: form
        })
    }

    updateOferta(form) {
        return graphqlClient.mutate({
            mutation: require('./gql/ofertaUpdate.graphql'),
            variables: form
        })
    }

    deleteOferta(id) {
        return graphqlClient.mutate({
            mutation: require('./gql/ofertaDelete.graphql'),
            variables: { id }
        })
    }

    getOfertasAplicables(itemsCarrito, depositoId, medioDePago = null, fecha = null) {
        return graphqlClient.query({
            query: require('./gql/ofertasAplicablesMovimiento.graphql'),
            variables: { 
                itemsCarrito, 
                deposito: depositoId, 
                medioDePago, 
                fecha 
            },
            fetchPolicy: "network-only" // Siempre obtener datos frescos para ofertas
        })
    }

}

export default new OfertaProvider()

